import { render, staticRenderFns } from "./MapLegendCard.vue?vue&type=template&id=3d7ae972&scoped=true"
import script from "./MapLegendCard.vue?vue&type=script&lang=ts"
export * from "./MapLegendCard.vue?vue&type=script&lang=ts"
function injectStyles (context) {
  
  var style0 = require("./MapLegendCard.vue?vue&type=style&index=0&id=3d7ae972&prod&scoped=true&lang=less")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "3d7ae972",
  null
  ,true
)

export default component.exports